import { Anchor, Box, Breadcrumbs, Card, Container, Text } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import ErrorMessage from '../../components/ErrorMessage';
import SearchableCombobox from '../../components/SearchableCombobox';
import Spinner from '../../components/Spinner';
import InvoiceForm from '../../components/SuperAdmin/InvoiceForm';
import superAdminAccents from '../../components/SuperAdmin/superAdminAccents.module.css';
import useFetch from '../../helpers/useFetch';

const SuperAdminInvoiceNewPage = () => {
  const fetch = useFetch();
  const navigate = useNavigate();
  const [accounts, setAccounts] = useState();
  const [loadError, setLoadError] = useState();
  const [invoice, setInvoice] = useState();

  useEffect(() => {
    fetch(`/api/admin/accounts`)
      .then(({ accounts }) => {
        setAccounts(accounts);
      })
      .catch(setLoadError);
  }, [fetch]);

  const save = (setLoading) => {
    setLoading(true);
    fetch(`/api/admin/invoices`, {
      method: 'POST',
      body: JSON.stringify({ invoice }),
    })
      .then(() => navigate('/superAdmin'))
      .finally(() => setLoading(false));
  };

  if (accounts === undefined) {
    return <Spinner />;
  }

  if (invoice === null) {
    return <ErrorMessage message="Invoice does not exist!" />;
  }

  if (loadError) {
    return <ErrorMessage message={loadError.message} />;
  }

  const accountOptions = accounts.map((a) => ({ label: a.name, value: a.id.toString() }));

  const breadcrumbItems = [{ title: 'Super Admin', href: '#/superAdmin' }, { title: 'New Invoice' }].map(
    (item, index) =>
      item.href ? (
        <Anchor href={item.href} key={index}>
          {item.title}
        </Anchor>
      ) : (
        <Text key={index}>{item.title}</Text>
      )
  );

  return (
    <Container pt="md" style={{ maxWidth: '1280px' }}>
      <Breadcrumbs mb="md">{breadcrumbItems}</Breadcrumbs>

      <Box className={superAdminAccents.page}>
        <Card withBorder>
          <SearchableCombobox
            placeholder="Select account to invoice..."
            options={accountOptions}
            onChange={(value) => {
              const account = accounts.find((a) => a.id.toString() === value);

              if (!account) {
                return;
              }

              setInvoice({
                day: new Date().toISOString().split('T')[0],
                accountId: account.id,
                type: 'invoice',
                currency: account.invoiceCurrency,
                templateData: {
                  lineItems: [
                    {
                      description: 'Please provide description of services here',
                      unitPrice: {
                        price: 0,
                        currency: account.invoiceCurrency,
                      },
                      quantity: 1,
                    },
                  ],
                },
              });
            }}
            value={invoice?.accountId?.toString()}
          />

          <hr />
          <InvoiceForm invoice={invoice} setInvoice={setInvoice} save={save} />
        </Card>
      </Box>
    </Container>
  );
};
export default SuperAdminInvoiceNewPage;
